export default "__VITE_ASSET__DcRpTniY__"